// extracted by mini-css-extract-plugin
export default {"image":"S5-z","loaded":"T5-z"};